// test17
(17 && 0);
